import type { ReactNode } from 'react';

export const symbol_meeting_room: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M150-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h62v-630q0-12.75 8.63-21.38Q229.25-840 242-840h330q12.75 0 21.38 8.62Q602-822.75 602-810v15h117q12.75 0 21.38 8.62Q749-777.75 749-765v585h61q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-91q-12.75 0-21.37-8.63Q689-137.25 689-150v-585h-87v585q0 12.75-8.62 21.37Q584.75-120 572-120H150Zm122-660v600-600Zm207.5 271.5Q468-520 451-520t-28.5 11.5Q411-497 411-480t11.5 28.5Q434-440 451-440t28.5-11.5Q491-463 491-480t-11.5-28.5ZM272-180h270v-600H272v600Z"
		/>
	</svg>
);
